import { SpaceStatusElement } from "./elements/space-status.ts";

export type SpaceAPIResponse = {
  api_compatibility: ["15"];
  location: {
    address: string;
    lat: number;
    lon: number;
    timezone: string;
    country_code: string;
  };
  state: {
    open: boolean;
    lastchange: number;
  };
  contact: {
    bluesky: string;
    email: string;
    mastodon: string;
  };
  sensors: {
    humidity: Array<{
      value: number;
      unit: string;
      location: string;
      name: string;
      lastchange: number;
    }>;
    temperature: Array<{
      value: number;
      unit: string;
      location: string;
      name: string;
      lastchange: number;
    }>;
  };
  feeds: {
    calendar: {
      type: string;
      url: string;
    };
  };
  links: Array<{
    name: string;
    url: string;
  }>;
};

export async function get(url = "/spaceapi.json"): Promise<SpaceAPIResponse> {
  const resp = await fetch(url);
  if (!resp.ok) {
    throw new Error(`Failed to fetch SpaceAPI: ${resp.statusText}`);
  }
  return await resp.json();
}
